import * as React from 'react';
import { DesktopBannerLayout } from '../../components/Banner';
import { IInformerBanner } from '../../types/informerBanner';
import { usePrelandingProps } from '../../hooks/usePrelandingProps';
import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { trackBannerShow } from '../ConsultationTrap/tracking';
import { useApplicationContext } from '../../utils/applicationContext';
import { tackShowInformBanner } from './tracking';
import { CpdConsultationExperiment } from '../ConsultationTrap/experiment';

// TODO: перенести в RS после окончания эксперимента
const CONSULTATION_BANNER_PROPS: IInformerBanner['bannerData'] = {
  uniqueBannerId: 'consultationBanner',
  analyticsBannerType: 'consultation',
  description: 'Есть вопросы о продаже? Наш эксперт поможет разобраться бесплатно.',
  desktopData: {
    labelData: {
      labelText: 'Новое',
      labelColor: 'white',
      labelBackground: 'error_100',
    },
  },
  mobileData: {
    backgroundGradient: 'linear-gradient(180deg, #C1E8FD 0%, #FFEBAF 100%);',
    labelData: {
      labelText: 'Новое',
      labelColor: 'white',
      labelBackground: 'primary_100',
    },
  },
};

export const FormAnnotationContainer: React.FC = () => {
  const experimentGroup = CpdConsultationExperiment.use();
  const { config } = useApplicationContext();
  const informerBannerConfig = config.get<IInformerBanner>('valuationInformerBannerConfig');

  const { handleBannerClick } = usePrelandingProps();

  if (experimentGroup === 'B') {
    return (
      <ActionAfterViewObserver callback={() => trackBannerShow('CpdConsultationTextLink')}>
        <DesktopBannerLayout
          action={{ label: 'Задать вопрос', onClick: () => handleBannerClick('CpdConsultationTextLink') }}
          {...CONSULTATION_BANNER_PROPS}
        />
      </ActionAfterViewObserver>
    );
  }

  if (informerBannerConfig?.bannerData) {
    const { bannerData } = informerBannerConfig;

    return (
      <ActionAfterViewObserver callback={() => tackShowInformBanner(bannerData.analyticsBannerType)}>
        <DesktopBannerLayout {...bannerData} />
      </ActionAfterViewObserver>
    );
  }

  return null;
};
